<!-- header Start-->
<section class="event header" id="home">
    <div class="header3 bg" [ngStyle]="{'background-image': 'url(assets/images/event/event_slider.jpg)'}">
        <div class="event-content">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <div class="center-text" [@bounce]="{ value: bounce }">
                            <div class="text-center w-100">
                                <div class="h1-margin">
                                    <!-- <h1 class="header-title">
                                        <span style="font-size: larger; color: #474747; font-family: Impact !important;">RAPOL APP</span>
                                    </h1>
                                    <h6 style="color: #525252;">Powered by ERPat System </h6> -->
                                    <button (click)="logout()" style="margin-top: 20px;">Logout</button>
                                </div>
                                <div class="wedding-time scrollbox">
                                    <div class="row">
                                        <div class="col-sm-3 col-12" *ngFor="let current of raffles; index as page;">
                                            <div class="countdown-container" style="padding: 20px 30px;">
                                                <div class="cd-wrapper" (click)="onClickTitle(current.uuid)" style="cursor: pointer;">
                                                    <div class="cd-body mb-3">
                                                        <span class="titles"><h5 style="color: rgb(121, 121, 121);">{{current.title}}</h5></span>
                                                    </div>
                                                    <div class="cd-footer">
                                                        <span class="details text-dark">Raffle: {{current.raffle_type.toUpperCase()}}</span>
                                                        <span class="details text-dark">Winners: {{current.winners}}</span>
                                                        <span class="details text-dark mt-1">{{current.crowd_type}}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- <div class="set-bottom set-abs">
            <a class="center-content down" (click)="onRedirect($event)">
                <img src="assets/images/image-down.png" alt="" class="scroll-down">
            </a>
        </div> -->
    </div>
</section>
<!-- header end-->